import React from "react";

import { mdiAlertRemoveOutline, mdiCheckCircleOutline } from "@mdi/js";
import Icon from "@mdi/react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import type { JSX } from "react";

interface Props {
  uploadProgress: number;
  isUploadSuccess: boolean;
  isUploadError: boolean;
}

export default function UploadZoneProgress({
  uploadProgress,
  isUploadSuccess,
  isUploadError,
}: Props): JSX.Element {
  const { t } = useTranslation("forms");
  const uploadStatusClassnames = classNames(
    "flex flex-col items-center justify-center",
    {
      "text-status-active": isUploadSuccess,
      "text-destructive": isUploadError,
    },
  );

  const renderUploadStatus = (): JSX.Element => {
    if (isUploadSuccess) {
      return (
        <div className={uploadStatusClassnames}>
          <Icon path={mdiCheckCircleOutline} size={1.25} />
          <p className="mt-[0.3125rem]">{t("imageUploadSuccess")}</p>
        </div>
      );
    }

    if (isUploadError) {
      return (
        <div className={uploadStatusClassnames}>
          <Icon path={mdiAlertRemoveOutline} size={1.25} />
          <p className="mt-[0.3125rem]">{t("imageUploadError")}</p>
        </div>
      );
    }

    return (
      <div className="bg-border-strong h-[0.3125rem] w-full rounded-full">
        <div
          className="bg-primary h-[0.3125rem] rounded-full"
          style={{ width: `${uploadProgress}%` }}
        />
        <p className="mt-[0.3125rem]">
          {t("imageUploadProgress", { uploadProgress })}
        </p>
      </div>
    );
  };

  return (
    <div className="bg-card/90 flex size-full items-center justify-center p-[2.5rem] backdrop-blur-sm">
      {renderUploadStatus()}
    </div>
  );
}
